
document.addEventListener('DOMContentLoaded', () => {
  let lang = 'ar';
  const langBtn = document.getElementById('langBtn');

  if (langBtn) {
    langBtn.addEventListener('click', () => {
      lang = lang === 'ar' ? 'en' : 'ar';
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.querySelectorAll('[data-ar][data-en]').forEach(el => {
        el.textContent = el.dataset[lang];
      });
      langBtn.textContent = lang === 'ar' ? 'English' : 'العربية';
    });
  }

  let qty = 1;
  const qtyEl = document.getElementById('qty');
  const qtyInput = document.getElementById('q8QtyInput');
  const totalEl = document.getElementById('total');
  const plus = document.getElementById('plus');
  const minus = document.getElementById('minus');

  function moneyFromCents(cents) {
    return (Number(cents || 0) / 100).toFixed(2) + ' د.ك';
  }
  function updateQty() {
    if (qtyEl) qtyEl.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
    if (totalEl && totalEl.dataset.unitPrice) {
      totalEl.textContent = moneyFromCents(Number(totalEl.dataset.unitPrice) * qty);
    }
  }
  if (plus) plus.addEventListener('click', () => { qty++; updateQty(); });
  if (minus) minus.addEventListener('click', () => { if (qty > 1) qty--; updateQty(); });

  const productForm = document.getElementById('q8ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      });
      if (response.ok) window.location.href = '/checkout';
      else productForm.submit();
    });
  }

  const win = document.getElementById('reviewsWindow');
  const track = document.getElementById('reviewsTrack');
  if (win && track) {
    let x = 0, paused = false, last = performance.now();
    const speed = 18;
    function tick(now) {
      const dt = Math.min((now - last) / 1000, 0.05);
      last = now;
      if (!paused) {
        x -= speed * dt;
        const half = track.scrollWidth / 2;
        if (half > 0 && -x >= half) x += half;
        track.style.transform = `translate3d(${x}px,0,0)`;
      }
      requestAnimationFrame(tick);
    }
    const pause = () => paused = true;
    const resume = () => { paused = false; last = performance.now(); };
    ['touchstart','pointerdown'].forEach(evt => win.addEventListener(evt, pause, {passive:true}));
    ['touchend','touchcancel','pointerup','pointercancel','pointerleave'].forEach(evt => win.addEventListener(evt, resume, {passive:true}));
    requestAnimationFrame(tick);
  }
});
